/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  const handleABTest = () => {
    const shippingAndDeliveryAcc = document.querySelector(
      ".shippingAndReturns"
    );
    const qualityToBeProud = document.querySelector(".qualityToBeProud");
    const matchMed = matchMedia("(max-width: 768px)");
    if (matchMed.matches) {
      shippingAndDeliveryAcc.querySelector(".accordion__title").innerText =
        "Shipping & Returns";
      qualityToBeProud.querySelector(".hero__title").innerText =
        "Quality to be proud of. ";
    } else {
      shippingAndDeliveryAcc.querySelector(".accordion__title").innerText =
        "Delivery";
      qualityToBeProud.querySelector(".hero__title").innerText =
        "A focus on the sourcing of our materials";
    }
  };

  if (document.querySelector('.index-product[data-section-type="product"]')) {
    window.addEventListener("resize", (e) => {
      handleABTest();
    });
    handleABTest();
  }

  window.initCustomFilterDropdowns = () => {
    //Close dropdown filter:
    const closeFilter = (summary, programatically) => {
      if (programatically) {
        summary.parentElement.open = false;
        summary.parentElement.querySelector(".filter-group__body").style = "";
      } else {
        summary.classList.add("clicked");
        summary.click();
        summary.classList.remove("clicked");
      }
      summary.closest(".filter-group").classList.remove("isActive");
    };

    //Collection filters:
    const handleFilterClick = (item) => {
      //Clicked by our own function in order to have the theme take over transitions etc, so no need to process.
      if (item.classList.contains("clicked")) return;
      item.closest(".filter-group").classList.add("isActive");
      dropdownFilters.forEach((summary) => {
        if (summary != item && summary.parentElement.open) {
          closeFilter(summary);
        }
      });
    };
    const dropdownFilters = document.querySelectorAll(
      ".collection__sidebar.collection__sidebar--dropdown summary"
    );

    if (dropdownFilters.length) {
      dropdownFilters.forEach((filter) => {
        filter.addEventListener("click", handleFilterClick.bind(this, filter));
      });
      //Close any filter open in case of clicking anywhere else:
      document.addEventListener("click", (e) => {
        if (!e.target.closest(".filter-group")) {
          dropdownFilters.forEach((filter) => {
            if (filter.parentElement.open) {
              closeFilter(filter, true);
            }
          });
        }
      });
    }
  };

  initCustomFilterDropdowns();

  //Cart Drawer Free Shipping:
  const initFreeShippingChanges = async () => {
    const userLocation = Pandectes.geolocation;
    if (userLocation.country != "US") {
      const rebuyCartDrawer = document.querySelector("#rebuy-cart");
      rebuyCartDrawer.setAttribute("data-custom-shipping", true);

      const freeShippingCustomSection = document.createElement("div");
      freeShippingCustomSection.innerHTML = `
          <div class="rebuy-cart__progress-step complete" style="width: 100%;">
            <div class="rebuy-cart__progress-step-icon">
              <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.82415 6.15237L0.726419 4.05464L0.012085 4.76395L2.82415 7.57601L8.86078 1.53938L8.15147 0.830078L2.82415 6.15237Z" fill="white"></path>
              </svg>
            </div>
            <p class="rebuy-cart__progress-step-label"></p>
          </div>
          `;
      freeShippingCustomSection.classList.add("freeShippingCustomSection");

      //Sometimes, no Shipping section is added by the time this function runs.
      if (userLocation.country == "GB") {
        const customProgressBar = document.createElement("div");
        customProgressBar.className = "rebuy-cart__progress-bar-meter";
        customProgressBar.style.maxWidth = "90%";
        customProgressBar.style.marginLeft = "auto";
        customProgressBar.style.marginRight = "auto";
        customProgressBar.innerHTML = `
              <div role="progressbar" tabindex="0" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" aria-labelledby="rebuy-cart__progress-bar-meter-label" class="rebuy-cart__progress-bar-meter-fill" style="width: 100%;"><span class="sr-only"></span></div>
            `;
        freeShippingCustomSection.prepend(customProgressBar);
        freeShippingCustomSection.classList.add("ukShipping");
        freeShippingCustomSection.querySelector("p").innerText =
          "🎉 Free Shipping";
      } else {
        freeShippingCustomSection.querySelector("p").innerText =
          "Worldwide Shipping Available";
      }

      const flyoutBody = document.querySelector(".rebuy-cart__flyout-body");
      flyoutBody.insertBefore(
        freeShippingCustomSection,
        flyoutBody.querySelector("[data-scroll-lock-scrollable]")
      );
    }
  };

  const awaitRebuyInit = setInterval(() => {
    if (
      typeof Pandectes != "undefined" &&
      typeof Pandectes.geolocation != "undefined" &&
      Pandectes.geolocation.country != null &&
      typeof Rebuy != "undefined" &&
      Rebuy.Cart &&
      Rebuy.Cart.status === "ready" &&
      document.querySelector("#rebuy-cart")
    ) {
      clearInterval(awaitRebuyInit);
      initFreeShippingChanges();
    }
  }, 500);
})();



/************************************************************************************

PRODUCT CUSTOMIZE

*************************************************************************************/

if (!customElements.get('l-product-sizeguide-popup')) {
  customElements.define(
    'l-product-sizeguide-popup',
    class ProductSizeGuidePopup extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Trigger event code placed in Hulk Product Option -> Settings -> `Custom JS`
        // document.dispatchEvent(new Event("hulkapp:loaded", {bubbles: true}))

        document.addEventListener('hulkapp:loaded', () => {
          this.setHulkLoaded()
        })
      }

      setHulkLoaded() {
        const hulkOption = document.querySelector('.js-popup-option .hulkapps_option_name')
        if (!hulkOption) return

        console.log("l-product-sizeguide-popup");
        console.log("l-product-sizeguide-popup");
        console.log("l-product-sizeguide-popup");
        console.log("l-product-sizeguide-popup");
        console.log("l-product-sizeguide-popup");
        console.log("l-product-sizeguide-popup");
        console.log("l-product-sizeguide-popup");
        console.log("l-product-sizeguide-popup");
        console.log("l-product-sizeguide-popup");
        console.log("l-product-sizeguide-popup");


        hulkOption.insertAdjacentHTML('beforeend', this.innerHTML)
      }
    }
  );
}
